import { useTranslation } from "react-i18next"

import { useEvent } from "shared/lib/useEvent"
import { useRequestToasts } from "shared/lib/useRequestToasts"

import { useChangeProjectOwnerMutation } from "entities/projects/graphql/mutations.generated"

export function useChangeProjectOwner() {
  const { t } = useTranslation()
  const [mutate, rest] = useChangeProjectOwnerMutation()

  const { raiseLoadingToast } = useRequestToasts({
    messages: {
      loading: t("Request.Project.CHANGE_PROJECT_OWNER.Start"),
      success: t("Request.Project.CHANGE_PROJECT_OWNER.Success"),
      failure: t("Request.Project.CHANGE_PROJECT_OWNER.Failure")
    }
  })

  const handleChangeProjectOwner = useEvent(
    (
      {
        projectID,
        teamID
      }: {
        projectID: string
        teamID: string
      },
      options?: { suppressToasts?: boolean }
    ) => {
      const { raiseSuccessToast, raiseErrorToast } = raiseLoadingToast({
        suppress: !!options?.suppressToasts
      })

      return mutate({
        variables: {
          id: projectID,
          input: {
            id: projectID,
            team: teamID
          }
        },
        onError: () => {
          raiseErrorToast()
        },
        onCompleted: () => {
          raiseSuccessToast()
        }
      })
    }
  )

  return {
    changeProjectOwner: handleChangeProjectOwner,
    ...rest
  }
}
